var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseScreen = function SvgCloseScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.997
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.113 8.997 6.444-6.429A1.505 1.505 0 1 0 15.429.44L9 6.884 2.571.441A1.505 1.505 0 0 0 .443 2.569l6.444 6.429-6.444 6.428a1.505 1.505 0 1 0 2.128 2.128L9 11.11l6.429 6.444a1.505 1.505 0 1 0 2.128-2.128Z"
  })));
};
export default SvgCloseScreen;